import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KidBackground from '../ui/backgrounds/KidBackground';
import ArtmosphereNavbar from '../components/ArtmosphereNavbar';
import splashImage from '../assets/splash.png';

export default function OrderConfirmation() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const etaDays = state?.etaDays || 5;
  const printMode = state?.printMode || false;
  return (
    <div className="min-h-screen relative bg-[#FFF8E1] flex flex-col">
      <KidBackground variant="blobs" intensity={1} />
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50/80 to-yellow-100/80 pointer-events-none" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-amber-200/20 rounded-full blur-3xl" />
        <div className="absolute bottom-40 left-10 w-96 h-96 bg-amber-300/15 rounded-full blur-3xl" />
      </div>
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-[1]">
        <img src={splashImage} alt="" className="absolute top-10 right-5 opacity-15 w-[400px] h-[200px] object-cover rotate-12 mix-blend-multiply blur-[2px]" />
        <img src={splashImage} alt="" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10 w-[300px] h-[150px] object-cover rotate-[-10deg] mix-blend-multiply blur-[3px]" />
      </div>

      <div className="relative z-10 flex-1 flex items-center justify-center px-3 sm:px-4 md:px-[2.5cm] py-8">
        <div className="w-full max-w-2xl">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl md:rounded-[32px] shadow-2xl border-2 border-amber-200/80 overflow-hidden">
            <div className="border-b border-amber-200/60 px-4 sm:px-6">
              <ArtmosphereNavbar title="Artmosphere" subtitle="Order confirmation" embedded />
            </div>
            <div className="p-6 sm:p-8 md:p-10 text-center">
              <div className="text-4xl mb-4">✨</div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                {printMode ? (state?.selectedBooks?.[0]?.isDailyActs ? 'Daily Acts Print Order Placed!' : 'Print Order Placed!') : 'Order placed successfully!'}
              </h1>
              <p className="text-gray-700 mb-5 leading-relaxed">
                {printMode
                  ? (state?.selectedBooks?.[0]?.isDailyActs
                      ? "Your daily acts book has been queued for printing! We'll start creating your beautiful printed collection right away. An email confirmation with print details and delivery information has been sent to you."
                      : "Your book has been queued for printing! We'll start creating your beautiful printed copy right away. An email confirmation with print details and delivery information has been sent to you."
                    )
                  : "Your order has been shipped successfully. An email confirmation with details and an expected delivery date has been sent to you."}
              </p>
              <div className="p-4 rounded-xl bg-amber-50 border border-amber-200 text-gray-800 mb-6 inline-block">
                {printMode
                  ? (state?.selectedBooks?.[0]?.isDailyActs
                      ? <>Estimated daily acts book print completion and delivery in <strong>{etaDays} days</strong>.</>
                      : <>Estimated print completion and delivery in <strong>{etaDays} days</strong>.</>
                    )
                  : <>Estimated delivery in <strong>{etaDays} days</strong>.</>}
              </div>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={() => navigate('/')}
                  className="px-5 py-2.5 rounded-xl bg-amber-500 hover:bg-amber-600 text-white font-semibold shadow transition-colors"
                >
                  Artist Corner
                </button>
                <button
                  onClick={() => navigate(printMode ? (state?.selectedBooks?.[0]?.isDailyActs ? '/daily-activities' : '/my-art-stories') : '/artist-wall')}
                  className="px-5 py-2.5 rounded-xl border-2 border-amber-300 text-amber-800 hover:bg-amber-50 font-semibold transition-colors"
                >
                  {printMode ? (state?.selectedBooks?.[0]?.isDailyActs ? 'Back to Daily Activities' : 'Back to My Stories') : 'Back to My Gallery'}
                </button>
                <button
                  onClick={() => navigate(printMode ? (state?.selectedBooks?.[0]?.isDailyActs ? '/daily-activities' : '/my-art-stories') : '/create-books')}
                  className="px-5 py-2.5 rounded-xl border-2 border-amber-300 text-amber-800 hover:bg-amber-50 font-semibold transition-colors"
                >
                  {printMode ? 'Back to My Stories' : 'Back to Artmosphere Collection'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
